import React from "react";
import Contact from "../Components/contact/Contact";
import Spacer2 from "../Components/common/Spacer2";
import PageHeader from "../Components/common/PageHeader";
import SEO from "../Components/common/SEO";
import { t } from "i18next";

function ContactPage() {
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/iletisim`;

  const contactStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    'name': 'Seymen Kimya İletişim',
    'description': 'Seymen Kimya ile iletişime geçin',
    'url': pageUrl,
    'mainEntity': {
      '@type': 'LocalBusiness',
      'name': 'Seymen Kimya',
      'description': 'Profesyonel temizlik ve kimyasal ürünler üreticisi',
      'telephone': '+90-224-360-1166',
      'email': 'info@seymenkimya.com',
      'address': {
        '@type': 'PostalAddress',
        'addressCountry': 'TR',
        'addressLocality': 'Bursa',
        'addressRegion': 'Bursa'
      },
      'geo': {
        '@type': 'GeoCoordinates',
        'latitude': '40.1826',
        'longitude': '29.0665'
      },
      'openingHours': 'Mo-Fr 08:00-17:00',
      'priceRange': '$',
      'servesCuisine': 'Kimyasal Ürünler'
    }
  };

  return (
    <>
      <SEO
        title="İletişim | Seymen Kimya - Bize Ulaşın"
        description="Seymen Kimya ile iletişime geçin. Ürünlerimiz hakkında bilgi almak ve sipariş vermek için bizimle iletişime geçebilirsiniz. Tel: (0224) 360 1166"
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/contact/contact.webp`}
        structuredData={contactStructuredData}
      />
      <PageHeader title={t("İletişim")}/>
      <Spacer2/>
      <Contact />  
    </>
  );
}

export default ContactPage;
